module.exports = __webpack_public_path__ + "static/preview-tabs-position-horizontal-cb705cf047f4324fe8551e94a7c760a5.png";